export const OPEN_SETTING = "OPEN_SETTING";
